"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var ToolBarDateRangeFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionCopy_1 = require("../../../../../../shared/components/table_actions/TableActionCopy");
var SupportPlayerPersonalPromoCodesList = /** @class */ (function (_super) {
    __extends(SupportPlayerPersonalPromoCodesList, _super);
    function SupportPlayerPersonalPromoCodesList(props) {
        return _super.call(this, props) || this;
    }
    SupportPlayerPersonalPromoCodesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            searchDescriptionFilter: [],
            searchDescriptionValue: "",
            searchTitleFilter: [],
            searchTitleValue: "",
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat(),
        }, function () {
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath(["Персональный промокоды"]);
    };
    SupportPlayerPersonalPromoCodesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    SupportPlayerPersonalPromoCodesList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize
            }, function () {
                _this.loadData(_this.props);
            });
        }
    };
    SupportPlayerPersonalPromoCodesList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadData({
            BrandIdList: this.props.brandsList,
            AllBrands: this.props.allBrands,
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    SupportPlayerPersonalPromoCodesList.prototype.onCopyLinkClick = function (record) {
        var el = document.createElement('textarea');
        el.value = "" + record.message_to_player;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041E\u0442\u0432\u0435\u0442 \u0438\u0433\u0440\u043E\u043A\u0443 \u0431\u044B\u043B \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430"));
    };
    SupportPlayerPersonalPromoCodesList.prototype.getColumns = function () {
        var _this = this;
        return [{
                title: 'Промокод',
                dataIndex: this.props.data.dk_promo_code_title,
                key: this.props.data.dk_promo_code_title,
                width: 200,
            }, {
                title: 'Бренд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                width: 200,
            }, {
                title: 'Игрок',
                dataIndex: this.props.data.dk_player_login,
                key: this.props.data.dk_player_login,
                width: 200,
            }, {
                title: 'Сотрудник',
                dataIndex: this.props.data.dk_admin_login,
                key: this.props.data.dk_admin_login,
                width: 200,
            }, {
                title: 'Сообщение',
                dataIndex: this.props.data.dk_message_to_player,
                key: this.props.data.dk_message_to_player,
                width: 200,
            }, {
                title: 'Создан',
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionCopy_1.default, { hint: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u0431\u0443\u0444\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430", onClick: function () { _this.onCopyLinkClick(record); } }))); },
                width: 120
            }];
    };
    SupportPlayerPersonalPromoCodesList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.loadData(_this.props, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, _PageSize);
                }
            });
        });
    };
    SupportPlayerPersonalPromoCodesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    SupportPlayerPersonalPromoCodesList.prototype.OnBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    SupportPlayerPersonalPromoCodesList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    SupportPlayerPersonalPromoCodesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.OnBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435:"),
                            " [",
                            record.message_to_player,
                            "]")));
                }, scroll: { x: true } })));
    };
    return SupportPlayerPersonalPromoCodesList;
}(React.Component));
exports.default = SupportPlayerPersonalPromoCodesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/support_player_personal_promocodes/ui/component/SupportPlayerPersonalPromoCodesList.tsx
// module id = 2586
// module chunks = 0